import { Modal, Form, Input, Select, ColorPicker } from 'antd';
import { usePostProjectDrawingIdMutation } from '../features/api/apiSlice';

export default function EditDrawingForm(props) {
  const { open, setOpen, form, projectId } = props;
  const [postProjectDrawingId, { isLoading }] = usePostProjectDrawingIdMutation();

  const handleSave = () => {
    form
      .validateFields()
      .then(async ({ id, name, type, color }) => {
        form.resetFields();
        await postProjectDrawingId({ id, name, type, color, projectId }).unwrap();
        setOpen(false);
      })
      .catch((info) => console.log('Validate Failed:', info));
  };

  const hexValue = form.getFieldValue('color');

  return (
    <Modal
      open={open}
      title="Edit Drawing"
      okText="Update"
      cancelText="Cancel"
      centered
      onCancel={() => {
        form.resetFields();
        setOpen(false);
      }}
      onOk={handleSave}
      okButtonProps={{ loading: isLoading }}
      styles={{
        header: { padding: '20px 24px 0', marginBottom: 0 },
        body: { padding: '16px 24px 8px' },
        footer: { padding: '8px 24px 20px' },
      }}
    >
      <Form form={form} layout="vertical" style={{ marginTop: 8 }}>
        <Form.Item name="id" hidden>
          <Input />
        </Form.Item>
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: 'Please enter a name for the drawing' }]}
        >
          <Input placeholder="Drawing name" size="large" />
        </Form.Item>
        <Form.Item
          name="type"
          label="Type"
          rules={[{ required: true, message: 'Please select a type' }]}
        >
          <Select placeholder="Select drawing type" size="large">
            <Select.Option value="Layer">Layer</Select.Option>
            <Select.Option value="DP">Distribution Points</Select.Option>
            <Select.Option value="DPArea">DP Areas</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item name="color" label="Color">
          <ColorPicker
            format="hex"
            showText
            disabledAlpha
            size="large"
            value={hexValue}
            onChange={(c) => {
              form.setFieldValue('color', c.toHexString().toUpperCase());
            }}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}
